import React, { ReactElement, useMemo } from "react";
import { useParams } from "react-router";
import { PersonalInformation } from "@companion-core/shared/app/Components/MyAccount/Sections";
import { Security } from "@companion-core/shared/app/Components/MyAccount/Sections/Security";
import { DynamicSectionProps } from "@companion-core/shared/app/Components/MyAccount/DynamicSection/DynamicSection.model";
import { WizardStoreProvider } from "@companion-core/shared/app/Store/wizardStore";
import { Preferences } from "@companion-core/shared/app/Components/MyAccount/Sections/Preferences";

export const DynamicSection = ({ defaultSection }: DynamicSectionProps) => {
  const { section } = useParams();
  const SectionMap: Record<string, ReactElement> = {
    "information": <PersonalInformation />,
    "security": <Security />,
    "preferences": <Preferences />,
  };

  const currentSection = useMemo(() => section ?? defaultSection ?? "", [section, defaultSection]);

  const Section = () => SectionMap[currentSection];

  if (SectionMap[currentSection]) {
    return (
      <WizardStoreProvider>
        <Section />
      </WizardStoreProvider>
    );
  }
  return <div>The component {section} has not been created yet.</div>;
};
